import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedArticles from './components/FeaturedArticles';
import CategoryGrid from './components/CategoryGrid';
import ProductRecommendations from './components/ProductRecommendations';
import CommunitySection from './components/CommunitySection';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedArticles />
        <CategoryGrid />
        <ProductRecommendations />
        <CommunitySection />
      </main>
      <Footer />

      {/* Schema.org JSON-LD */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@graph': [
              {
                '@type': 'Organization',
                '@id': 'https://ruilongguoyao.cn/#organization',
                name: '少女领域',
                url: 'https://ruilongguoyao.cn/',
                description: '专属少女的梦幻世界，汇聚少女风格的时尚、美妆、生活方式与兴趣内容',
                logo: {
                  '@type': 'ImageObject',
                  url: 'https://ruilongguoyao.cn/logo.png',
                },
                sameAs: [
                  'https://weibo.com/shoujodomain',
                  'https://www.xiaohongshu.com/user/shoujodomain',
                ],
              },
              {
                '@type': 'WebSite',
                '@id': 'https://ruilongguoyao.cn/#website',
                url: 'https://ruilongguoyao.cn/',
                name: '少女领域',
                description: '专属少女的梦幻世界',
                publisher: { '@id': 'https://ruilongguoyao.cn/#organization' },
                inLanguage: 'zh-CN',
              },
              {
                '@type': 'WebPage',
                '@id': 'https://ruilongguoyao.cn/#webpage',
                url: 'https://ruilongguoyao.cn/',
                name: '少女领域 - 首页',
                description: '少女领域首页，汇聚少女风格的时尚穿搭、美妆教程、生活方式与兴趣内容',
                isPartOf: { '@id': 'https://ruilongguoyao.cn/#website' },
                about: { '@id': 'https://ruilongguoyao.cn/#organization' },
                inLanguage: 'zh-CN',
              },
            ],
          }),
        }}
      />
    </>
  );
}